import { SimpleGrid, Text, UnstyledButton } from "@mantine/core";
import { AssistantOrb } from "@/components/assistant/orb";
import type { AssistantOrbText } from "@/locales/assistant-orb";
import {
	type AssistantOrbConfig,
	defaultOrbParams,
	ORB_VARIANTS,
	type OrbVariant,
} from "@/types/ai-assistant-orb";

/** Sisi orb di kartu varian — cukup besar untuk membedakan bentuk, cukup kecil untuk murah. */
const CARD_ORB_PX = 44;

/**
 * Grid bentuk orb. Tiap kartu menampilkan orb yang benar-benar hidup dengan
 * warna yang sedang dipilih, bukan gambar mati — admin melihat hasilnya
 * sebelum memilih. Semuanya digerakkan satu loop rAF bersama.
 */
export function OrbVariantGrid({
	config,
	text,
	disabled,
	forceLight,
	onSelect,
}: {
	config: AssistantOrbConfig;
	text: AssistantOrbText;
	disabled: boolean;
	forceLight?: boolean;
	onSelect(variant: OrbVariant): void;
}) {
	return (
		<SimpleGrid cols={{ base: 3 }} spacing="sm" data-orb-variants>
			{ORB_VARIANTS.map((variant) => {
				const active = config.variant === variant;
				return (
					<UnstyledButton
						key={variant}
						type="button"
						disabled={disabled}
						aria-pressed={active}
						data-orb-variant={variant}
						onClick={() => onSelect(variant)}
						style={{
							border: `1px solid var(${active ? "--mantine-primary-color-filled" : "--mantine-color-default-border"})`,
							borderRadius: "var(--mantine-radius-md)",
							padding: "var(--mantine-spacing-sm)",
							textAlign: "center",
							opacity: disabled ? 0.6 : 1,
							cursor: disabled ? "not-allowed" : "pointer",
						}}
					>
						<div style={{ display: "grid", placeItems: "center" }}>
							<AssistantOrb
								// Tiap kartu memakai parameter bawaan varian-nya supaya yang
								// dibandingkan adalah bentuknya, bukan setelan varian lain.
								config={{
									...config,
									variant,
									params: defaultOrbParams(variant),
								}}
								name={text.variants[variant].name}
								size={CARD_ORB_PX}
								forceLight={forceLight}
							/>
						</div>
						<Text size="sm" fw={active ? 700 : 500} mt={6}>
							{text.variants[variant].name}
						</Text>
						<Text size="xs" c="dimmed" lh={1.3}>
							{text.variants[variant].hint}
						</Text>
					</UnstyledButton>
				);
			})}
		</SimpleGrid>
	);
}
